import * as yup from 'yup';

export const EditProfileSchema = yup.object({
    firstName: yup.string()
    .min(2, 'Name must be two or more characters')
    .max(255, 'Name must be less than or equal to 255 characters'),
    lastName: yup.string()
    .min(2, 'Last name must be two or more characters')
    .max(255, 'Last name must be less than or equal to 255 characters'),
});